<template>
  <div class="email-collection">
    <div class="form-field invalid">
      <label class="form-label">
        Email address

        <span class="mandatory-marker">
          *
        </span>
      </label>

      <input v-model="mutable.email"
             placeholder="Email address"
             class="form-control"
             :class="{ invalid: showValidation && !isValid }"
             type="email">

      <span v-if="showValidation && !isValid"
            class="validation-message">
        <template v-if="!isPopulated">
          Required
        </template>
        <template v-else-if="!isEmail">
          Not a valid email address
        </template>
      </span>
    </div>

    <div class="form-field invalid">
      <label class="form-label">
        Confirm email address

        <span class="mandatory-marker">
          *
        </span>
      </label>

      <input v-model="copy"
             placeholder="Confirm email address"
             class="form-control"
             :class="{ invalid: showValidation && !isValid }"
             type="email">

      <span v-if="showValidation && !isValid"
            class="validation-message">
        <template v-if="!copy">
          Required
        </template>
        <template v-else-if="!isConfirmed">
          Supplied email addresses do not match
        </template>
      </span>
    </div>
  </div>
</template>

<script>
import vmodelMixin from "~/mixins/vmodelMixin";
import validationMixin from "~/mixins/validationMixin";

const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export default {
  name: "FreeTextEmailCollectionMethod",
  mixins: [vmodelMixin, validationMixin],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: () => ( {
    mutable: null,
    copy: null
  } ),
  computed: {
    isPopulated () {
      let result = true;

      if ( !this.mutable.email ) {
        result = false;
      }

      return result;
    },
    isEmail () {
      let result = true;

      if ( this.mutable.email ) {
        if ( !this.mutable.email.match( emailRegex ) ) {
          result = false;
        }
      }

      return result;
    },
    isConfirmed () {
      let result = true;

      if ( this.mutable.email !== this.copy ) {
        result = false;
      }

      return result;
    },
    isValid () {
      let result = true;

      if ( !this.isPopulated ) {
        result = false;
      } else if ( !this.isEmail ) {
        result = false;
      } else if ( !this.isConfirmed ) {
        result = false;
      }

      return result;
    }
  },
  watch: {
    copy () {
      this.validate();
    },
    mutable: {
      deep: true,
      handler () {
        this.validate();
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>
